import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FR } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
export const DateWiseSearchWithPagination = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(2);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [state, setState] = useState({ loader: true, date: moment().subtract(1,"day").format("yyyy-MM-DD"), data: [], tableLoader: true ,
  tbHeader:[{title:"ID",name:"ID"},{title:"Name",name:"name"},{title:"Date",name:"Date"},{title:"CheckIn",name:"CheckIn"},{title:"CheckOut",name:"CheckOut"},{title:"spendTime",name:"spendTime"},{title:"details",name:"details"}],
  data:[]});
  const hours = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  const location = [
    {name:"wedding galleria 1",value:"001"},{name:"wedding galleria 2",value:"002"}
  ]
  const navigate=useNavigate();
  const apiData = async () => {
    try {
            setState((pre)=>{
      return {...pre,loader:true,tableLoader: true}
            })
      let data = {date:state.date,type:"Employee"}
      let result = await new FR().frInOut(data);
      console.log(result)
      if (!result.length) {
        alert("data not found");
      }
      let arr=[];
    let count=1;
   
     if(result.length){
     for(let val of result){
       arr.push([val.employeeId,val.employeeName,val.date,val.checkIn,val.checkOut,val.timeSpend,`<button type="button" data-emloyeeId=${val.employeeId} class="btn btn-theme details">Details</button>`])
       count++;
      }
    }
      setState((pre) => {
        return { ...pre, data: arr, loader: false, tableLoader: false }
      })
    } catch (e) {
      alert("error occur")
    }

  }
  const onHandler = (event) => {
    let date = null;
    if(event.target.name == "date"){
      date = moment(event.target.value).format("yyyy-MM-DD");
      setState((pre)=>{
        return {...pre,[event.target.name]:date}
          })
    }else{
      setState((pre)=>{
        return {...pre,[event.target.name]:Number(event.target.value)}
          })
    }
      
    // apiData(moment(month).format("yyyy-MM-DD"))
    
    console.log(state);
  }
  const showImage = (event) => {
    window.$("#modalImage").attr("src", event.target.src);
    window.$("#showImg").modal("show")

  }
  const onDetails=(employeeId)=>{
   navigate(`/employee-attendance-details/${employeeId}/${state.date}`);
  }
  useEffect(() => {

    apiData();
    setState((pre) => {
      return { ...pre}
    })
  }, []);
    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  
    // Export to CSV
    const exportToCSV = () => {
      // Implement CSV export logic
    };
  
    // Export to Excel
    const exportToExcel = () => {
      // Implement Excel export logic
    };
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div className="d-flex fw-bold small mb-3">
              <div className='row'></div>
              <div className="col-5">
                <span className="flex-grow-1">Employees FR Daily Report</span>
              </div>
              <div className="col-2">
                {/* <button type="button" class="btn btn-theme" onClick={exportCsv}>Export Csv</button> */}
                <div class="form-group mb-3" style={{ width: "85%" }}>
                  <label class="form-label" for="exampleFormControlSelect1">Select Date</label>
                  <input type="date" class="form-control text-white" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandler}/>
                </div>
              </div>
             
              <div className='col-2'>
                <label class="form-label" for="Location">Submit</label>
                <br />
                <button type="button" class="btn btn-theme" onClick={apiData}>Search</button>
              </div>
            </div>

            {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  {/* <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} onDetails={onDetails}  reverse={true}/> */}
  <table>
        {/* Table header */}
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            {/* Add more columns as needed */}
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {currentItems.map(item => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.email}</td>
              {/* Render more columns as needed */}
            </tr>
          ))}
        </tbody>
      </table>
      {/* Pagination controls */}
      <div>
        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
        <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentItems.length < itemsPerPage}>Next</button>
      </div>
      {/* Export options */}
      <div>
        <button onClick={exportToCSV}>Export to CSV</button>
        <button onClick={exportToExcel}>Export to Excel</button>
      </div>
  
   </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">

              <div class="modal-body">
                <img id="modalImage" src='' alt="nothing" style={{ width: "100%" }} />
              </div>

            </div>
          </div>
        </div>


      </>


    )
  }
  else {

    return (<>
      <Loader />
    </>)
  }

}
